import { type FC, useEffect } from "react";

import { type AppDefaultInfo, type BuilderInfo, type UserInfo } from "helpers/AppProvider.types";

import { initializeServiceCloudChat } from "utilities/thirdPartyIntegrations/serviceCloud/serviceCloud";

import {
    ServiceCloudConfig,
    ServiceCloudSettings,
} from "commonComponents/utilities/ClientChat/ServiceCloudTypes";

import "./ClientChat.less";

interface IClientChatProps {
    userInfo: UserInfo | undefined;
    appDefaultInfo: AppDefaultInfo;
    builderInfo: BuilderInfo | null;
    deferIntercomLoad?: boolean;
    children: React.ReactNode;
}

export const ClientChat: FC<IClientChatProps> = ({
    userInfo,
    appDefaultInfo,
    builderInfo,
    deferIntercomLoad,
    ...restProps
}) => {
    useEffect(() => {
        if (
            builderInfo &&
            userInfo?.supportChatSettings &&
            !userInfo?.isImpersonatingBuilder &&
            !deferIntercomLoad &&
            appDefaultInfo.enableServiceCloudChat
        ) {
            const settings = userInfo.supportChatSettings;
            const serviceCloudSettings = new ServiceCloudSettings({
                salesforceAccountId: settings.salesforceAccountId ?? "",
                serviceCloudConfig: new ServiceCloudConfig(settings.serviceCloudConfig),
                loginId: settings.loginId ?? "",
                globalUserId: settings.globalUserId ?? "",
                persona: settings.persona ?? "",
                companyName: settings.companyName ?? "",
                primaryContact: settings.primaryContact ?? "",
                displayName: settings.displayName ?? "",
                email: settings.email ?? "",
                cellPhone: settings.cellPhone ?? "",
            });

            initializeServiceCloudChat(serviceCloudSettings);
        }
    }, [userInfo, appDefaultInfo, builderInfo, deferIntercomLoad]);

    return <>{restProps.children}</>;
};
